module.exports = __webpack_public_path__ + "img/galeria-aquario-6.fd883a1e.jpg";